/*
* Created on Mar 08, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import React, {useEffect, useState} from 'react';
import ModalComponent from "../common/ModalComonent/ModalComponent";
import TextInputComponent from "../common/Form/TextInputComponent";
import ic_contact_svg from "../../static/img/utils/ic-contacts.svg";
import useToggle from "../../hook/ToggleHook";
import {useQuery, useQueryClient} from "@tanstack/react-query";
import ContactListInputComponent from "../common/Form/ContactListInputComponent";
import ic_arrow_down from "../../static/img/utils/ic-arrow-drop-down.svg";
import ic_remove from "../../static/img/utils/ic-remove.svg";
import {OverlayScrollbarsComponent} from "overlayscrollbars-react";
import {EMAIL_FORMAT, get_primary_email} from "../../service/common";
import {useTranslation} from "react-i18next";
import {useOrganizationApi} from "../../hook/OrganizationAPIHook";
import {useAuthService} from "../../hook/AuthServiceHook";
import {useOrganization} from "../../context/OrganizationContext";
import ic_info_inline_svg from "../../static/img/utils/ic-info-inline.svg";
import ic_contacts_svg from "../../static/img/utils/ic-contacts.svg";
import ic_minus_svg from "../../static/img/utils/ic-minus.svg";
import SelectInputComponent from "../common/Form/SelectInputComponent";

export const ROLE_LIST = {
    "Owner": "owner",
    'User Manager': "user_manager",
    'Member': "member"
}

export const ROLE_NOTES = {
    "Owner": '@Full control over the organization, members, roles, licenses and devices.@',
    "User Manager": '@Can invite users, manage members and groups. Cannot change or assign Owner roles.@',
    "Member": '@No user management rights. Other permissions are granted separately below.@'
}

// Role choices offered in the Invite Members dialog. Owners may invite any
// role; per the Org Role matrix (Confluence 1071979175) a User Manager
// "不可以邀請成為 owner" — non-owners cannot invite someone as Owner.
// Exported for unit testing.
export function inviteRoleOptions(isOwner) {
    const roles = Object.keys(ROLE_LIST); // Owner, User Manager, Member
    return isOwner ? roles : roles.filter(r => r !== 'Owner');
}

export const InviteContactComponent = ({setInviteList, validator, data, checkAddMore, effectCallback=null}) => {
    const {t} = useTranslation();
    const [showContact, setShowContact] = useState(false);
    const init_input = {
        qid: {value: data.value, error: data.error, required: data.required || false},
    }
    const [input, setInput] = useState(init_input);

    const onInputChange = (e) => {
        const value = e.target.value;

        setInput((prevInput) => {
            prevInput.qid = {
                ...prevInput.qid,
                value: value,
                error: validator ? validator(e) : null
            }
            return {...prevInput};
        });

    }

    const deleteInvite = () => {
        setInviteList(prev => {
            const newList = prev.filter((item, index) => item.key !== data.key);
            checkAddMore(newList);
            return newList
        });
    }

    useEffect(() => {
        if (effectCallback) {
            effectCallback(input, data);
        }
        else {
            setInviteList((prevInviteList) => {
                prevInviteList.map((item, index) => {
                    if (item.key === data.key) {
                        item.value = input.qid.value;
                        item.error = validator ? validator({target: {value: input?.qid?.value}}) : null;
                    }
                    return item;
                });
                checkAddMore(prevInviteList);
                return prevInviteList;
            });
        }
    }, [input?.qid?.value]);

    return (
        <div className="comp-contact-input">
            <div className="contact-input-group">
                <div className="contact-input-group__main">
                    <div className="comp-input">
                        <input type="text" placeholder={t('@Please input invitees Email@')} value={input.qid.value} name="qid" onChange={onInputChange} pattern={EMAIL_FORMAT} />
                        <div className="comp-dropdown hide"></div>
                    </div>
                    <div className="btn-contacts btn-contacts--search">
                        <img src={ic_contacts_svg} alt="" onClick={() => setShowContact(true)}/>
                        <ContactListInputComponent showContact={showContact} setShowContact={setShowContact} input={input} setInput={setInput} validate={validator}/>
                    </div>
                </div>
                { !data?.hideRemove &&
                    <div className="btn-contacts btn-contacts--remove" onClick={deleteInvite}>
                        <img src={ic_minus_svg} alt=""/>
                    </div>
                }
            </div>
            <div className={`text-error ${input?.qid?.error ? '' : 'hide'}`}>{input?.qid?.error}</div>
        </div>
    );
}

const AccountListInviteModalComponent = ({
                                             openModal, closeModal, organization_id, disPatcher, doRefresh
                                         }) => {
    const {t} = useTranslation();
    const {userProfile} = useOrganization();
    const {is_owner, permissions} = userProfile();
    const currentUser = JSON.parse(window.localStorage.getItem('currentUser'));
    const currentOrg = JSON.parse(window.localStorage.getItem('currentOrg'));
    const {OrganizationAPI} = useOrganizationApi();
    const [groups, setGroups] = useState([]);
    const {AUTHAPI} = useAuthService();
    const {} = useQuery({
        queryKey: [`organization/${organization_id}/group`],
        queryFn: async () => {
            const group_list = await OrganizationAPI.get(`organization/${organization_id}/group`, {limit: 200});
            setGroups(group_list.result);
            return group_list.result;
        }
    });

    const [canAddMoreInvite, setCanAddMoreInvite] = useState(false);
    const [open, node] = useToggle();
    const [permission, setPermission] = useState("");
    const queryClient = useQueryClient();

    const init_input = {
        role: {value: "", error: null, required: true},
        groups: {value: [], error: null, required: false}
    }
    const [input, setInput] = useState(init_input);
    const [inviteList, setInviteList] = useState([
        {value: "", error: null, required: true, showAddMore: true, hideRemove: false, key: new Date().getTime()}
    ]);

    const inviteAdmin = async () => {
        let input_data = {
            organization_id: organization_id,
            users: inviteList.map((i) => {
                let invite = {
                    qid: i.value,
                    groups: input.groups.value.map((g)=>g?.organization_group_id)
                };
                invite.role = ROLE_LIST[input.role.value];
                return invite;
            })
        };
        console.log('Invite Data:', input_data);
        await OrganizationAPI.post(`organization_invitation`, null, input_data);
        doRefresh((prevRefresh)=>prevRefresh + 1);
        closeModal();
    }

    const toggleGroup = (gp) => {
        setGroups((prevGroups)=>{
            return prevGroups.map((g)=>{
                if (g.organization_group_id === gp.organization_group_id) {
                    g.checked = !g.checked;
                    return g;
                }
                return g;
            });
        });
        setInput((prevInput)=>{
            return {
                ...prevInput,
                groups: {
                    ...prevInput.groups,
                    value: groups.filter((g)=>g.checked)
                }
            }
        });
    }

    const onSubmit = async () => {
        await inviteAdmin();
    }

    const validateEmailDomain = (e) => {
        const target_email = e.target.value;
        const current_org_users = currentOrg?.users || [];
        const valid = target_email.match(new RegExp(EMAIL_FORMAT));
        if (!valid) {
            return t('@Email format incorrent.@');
        }
        if (!is_owner && permissions?.invite_admin && target_email?.length > 0) {
            const curUser_email = currentUser.emails[0].email;
            if (target_email.split('@')[1].toLowerCase() !== curUser_email.split('@')[1].toLowerCase()) {
                return t('@Unable to invite people with a different domain@')
            }
        }
        if (current_org_users.find(u => u.email === target_email || u.qid === target_email) ) {
            return t('@User already exists in the Organization.@');
        }
        return ''
    }

    const onSubmitError = (error, alert) => {
        alert(true, 'error', error?.response?.data?.code, error?.response?.data?.message);
    }

    const canAddMore = (current_inviteList) => {
        const checkList = current_inviteList || inviteList;
        const valid = !checkList.some((i) => i.error) && !checkList.some((i) => !i.value);
        setCanAddMoreInvite(valid);
    }

    const addMore = () => {
        const key = new Date().getTime();
        setInviteList((prevInvites) => {
            const newInvite = {
                value: "",
                error: null,
                required: true,
                showAddMore: true,
                hideRemove: false,
                key
            };
            return [...prevInvites, newInvite];
        });
        if (!canAddMore()) return;
    }

    return (
        <ModalComponent isOpen={openModal} onClose={closeModal} onSubmit={onSubmit} title={t('@Invite Members@')} okText={t('@Invite@')} input={inviteList} preSubmit={(i)=>i.length > 0} onError={onSubmitError}>
            <div className="dialog-content">
                <div>{t('@You can invite administrators to a group. Invitees will be sent emails with a confirmation link. After clicking the link, they will be able to manage devices and services through the myQNAPcloud website.@')}</div>

                <div className="form-wrapper mt-24">
                    <form>
                        <SelectInputComponent label={t('@Role@')} field_name={'role'} input={input} setInput={setInput} empty_text={t('@Choose a role@')} listData={inviteRoleOptions(is_owner)} auto_width={false} useLocale={true} show_note={true} note_message={t(ROLE_NOTES?.[input?.role?.value]) || ""}/>

                        {groups?.length > 0 && <div className="form-row">
                            <div className="form-label"><label>{t('@Group@')}</label></div>
                            <div className="form-field">
                                <div className="comp-select" ref={node}>
                                    <div className="select-toggle">
                                        <span className="select-label">
                                            {groups?.filter((g) => g.checked).map((g) => g.name).join(', ')}
                                            {groups?.filter((g) => g.checked).length <= 0 ? t('@Select the group@') : ''}
                                        </span>
                                    </div>
                                    <div className={`comp-dropdown ${open === 'show' ? '' : 'hide'}`}>
                                        <ul className="comp-dropdown-menu">
                                            <li className="section add-scroll">
                                                {groups?.map((g, index) => {
                                                    return (
                                                        <div className="section-items" key={index}>
                                                            <div className="comp-checkbox">
                                                                <input type="checkbox" id={`cb-${index}`}
                                                                       onChange={() => toggleGroup(g)}
                                                                       checked={g.checked || false}/>
                                                                <label htmlFor={`cb-${index}`} className="comp-label">
                                                                    {g.name}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>}

                        <div className="form-row">
                            <div className="form-label required"><label>{t('@QNAP ID (Email Address)@')}</label></div>
                            <div className="form-field">
                                {
                                    inviteList.map((item, index) => <InviteContactComponent
                                        setInviteList={setInviteList}
                                        validator={validateEmailDomain}
                                        showAddMore={true}
                                        checkAddMore={canAddMore}
                                        data={{...item, index, showAddMore: index === inviteList.length - 1, hideRemove: inviteList.length===1}}
                                        key={item.key}/>)
                                }
                                <div className="contact-action-group">
                                    <button type="button" className="q-btn q-btn-primary q-btn-tiny q-btn-round-corner" disabled={!canAddMoreInvite} onClick={addMore}>{t('@Add Another@')}</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </ModalComponent>
    );
};

export default AccountListInviteModalComponent;